export default {
    Error: 'Error'
};
